import { ActionCreator, Action, Dispatch } from 'redux'
import { ThunkAction } from 'redux-thunk'
import { IKlantSelectie } from 'shared/models/IKlantSelectie'
import { IApplicationState } from '../store'
import GlnService from 'shared/service/GlnService'
import { IKlantGroepModel } from 'shared/models/IKlantGroepModel'
import { SelectieDescriptor } from 'shared/components/SelectieButton'
import { VestigingEnum } from 'shared/models/Enum'
import { IResponseAction } from '../interfaces'
import { IKlant } from 'shared/models/IKlant'
import { IKlantgroepAfleverafspraakModel } from './../../../shared/models/IKlantgroepAfleverafspraakModel'
import { IKlantAfleverafspraak } from './../../../shared/models/IKlantAfleverafspraak'

export enum Actions {
  GetKlantKoppelingRequest = 'GetKlantKoppelingRequest',
  GetKlantKoppelingResponse = 'GetKlantKoppelingResponse',
  PostKlantKoppelingRequest = 'PostKlantKoppelingRequest',
  PostKlantKoppelingResponse = 'PostKlantKoppelingResponse',
  DeleteKlantKoppelingRequest = 'DeleteKlantKoppelingRequest',
  DeleteKlantKoppelingResponse = 'DeleteKlantKoppelingResponse',
  GetKlantGroepenVestigingRequest = 'GetKlantGroepenVestigingRequest',
  GetKlantGroepenVestigingResponse = 'GetKlantGroepenVestigingResponse',
  GetKlantAfleverafsprakenVestigingRequest = 'GetKlantAfleverafsprakenVestigingRequest',
  GetKlantAfleverafsprakenVestigingResponse = 'GetKlantAfleverafsprakenVestigingResponse',
  GetKlantGroepenVestigingCache = 'GetKlantGroepenVestigingCache',
  GetKlantGegevensRequest = 'GetKlantGegevensRequest',
  GetKlantGegevensResponse = 'GetKlantGegevensResponse',
  GetKlantGegevensFout = 'GetKlantGegevensFout',
  GetKlantGroepenSelectieRequest = 'GetKlantGroepenSelectieRequest',
  GetKlantGroepenSelectieResponse = 'GetKlantGroepenSelectieResponse',
}

export interface IGetKlantKoppelingRequestAction
  extends Action<Actions.GetKlantKoppelingRequest> {
  payload: IKlantSelectie
}
export interface IGetKlantKoppelingResponseAction
  extends IResponseAction<Actions.GetKlantKoppelingResponse> {
  payload: IKlantgroepAfleverafspraakModel[]
}
export interface IPostKlantKoppelingRequestAction
  extends Action<Actions.PostKlantKoppelingRequest> {
  payload: IKlantgroepAfleverafspraakModel
}
export interface IPostKlantKoppelingResponseAction
  extends IResponseAction<Actions.PostKlantKoppelingResponse> {
  payload: string
}
export interface IDeleteKlantKoppelingRequestAction
  extends Action<Actions.DeleteKlantKoppelingRequest> {
  payload: IKlantgroepAfleverafspraakModel
}
export interface IDeleteKlantgroepAfleverafspraakResponseAction
  extends IResponseAction<Actions.DeleteKlantKoppelingResponse> {
  payload: string
}
export interface IGetKlantGroepenVestigingRequestAction
  extends Action<Actions.GetKlantGroepenVestigingRequest> {
  payload: number
}
export interface IGetKlantGroepenVestigingResponseAction
  extends IResponseAction<Actions.GetKlantGroepenVestigingResponse> {
  payload: SelectieDescriptor[]
}
export interface IGetKlantAfleverafsprakenVestigingRequestAction
  extends Action<Actions.GetKlantAfleverafsprakenVestigingRequest> {
  payload: any
}
export interface IGetKlantAfleverafsprakenVestigingResponseAction
  extends IResponseAction<Actions.GetKlantAfleverafsprakenVestigingResponse> {
  payload: SelectieDescriptor[]
}
export interface IGetKlantGroepenSelectieRequestAction
  extends Action<Actions.GetKlantGroepenSelectieRequest> {
  payload: number
}
export interface IGetKlantGroepenSelectieResponseAction
  extends IResponseAction<Actions.GetKlantGroepenSelectieResponse> {
  payload: SelectieDescriptor[]
}
export interface IGetKlantGroepenVestigingCacheAction
  extends Action<Actions.GetKlantGroepenVestigingCache> {
  payload: IKlantGroepModel[]
}
export interface IGetKlantGegevensRequestAction
  extends Action<Actions.GetKlantGegevensRequest> {
  payload: number
}
export interface IGetKlantGegevensResponseAction
  extends IResponseAction<Actions.GetKlantGegevensResponse> {
  payload: IKlant
}
export interface IGetKlantGegevensFoutAction
  extends Action<Actions.GetKlantGegevensFout> {
  payload: string
}

export type KlantKoppelingAction =
  | IGetKlantKoppelingRequestAction
  | IGetKlantKoppelingResponseAction
  | IPostKlantKoppelingRequestAction
  | IPostKlantKoppelingResponseAction
  | IDeleteKlantKoppelingRequestAction
  | IDeleteKlantgroepAfleverafspraakResponseAction
  | IGetKlantGroepenVestigingRequestAction
  | IGetKlantGroepenVestigingResponseAction
  | IGetKlantAfleverafsprakenVestigingRequestAction
  | IGetKlantAfleverafsprakenVestigingResponseAction
  | IGetKlantGegevensRequestAction
  | IGetKlantGegevensResponseAction
  | IGetKlantGroepenVestigingCacheAction
  | IGetKlantGegevensFoutAction
  | IGetKlantGroepenSelectieRequestAction
  | IGetKlantGroepenSelectieResponseAction

export const postKlantGroepAfleverafspraakActionCreator: ActionCreator<
  ThunkAction<
    Promise<IPostKlantKoppelingResponseAction>,
    IApplicationState,
    null,
    IPostKlantKoppelingResponseAction
  >
> = (klant: IKlantgroepAfleverafspraakModel) => {
  return async (dispatch: Dispatch, getState) => {
    const postDataAction: IPostKlantKoppelingRequestAction = {
      type: Actions.PostKlantKoppelingRequest,
      payload: klant,
    }
    dispatch(postDataAction)
    try {
      const result = await GlnService.postKlantgroepAfleverafspraak(klant)
      const reponse: IPostKlantKoppelingResponseAction = {
        success: result.success,
        errorMessage: result.errorMessage,
        payload: result.payLoad,
        type: Actions.PostKlantKoppelingResponse,
      }

      return dispatch(reponse)
    } catch (e) {
      const errorReponse: IPostKlantKoppelingResponseAction = {
        success: false,
        errorMessage: `fout bij opslaan klantgroepAfleverafspraak: ${e.message}`,
        payload: null,
        type: Actions.PostKlantKoppelingResponse,
      }

      return dispatch(errorReponse)
    }
  }
}

export const deleteKlantgroepAfleverafspraakActionCreator: ActionCreator<
  ThunkAction<
    Promise<IDeleteKlantgroepAfleverafspraakResponseAction>,
    IApplicationState,
    null,
    IDeleteKlantgroepAfleverafspraakResponseAction
  >
> = (klantGroepKoppeling: IKlantgroepAfleverafspraakModel) => {
  return async (dispatch: Dispatch, getState) => {
    const postDataAction: IDeleteKlantKoppelingRequestAction = {
      type: Actions.DeleteKlantKoppelingRequest,
      payload: klantGroepKoppeling,
    }
    dispatch(postDataAction)
    try {
      const result = await GlnService.verwijderKlantgroepAfleverafspraak(
        klantGroepKoppeling
      )
      const reponse: IDeleteKlantgroepAfleverafspraakResponseAction = {
        success: result.success,
        errorMessage: result.errorMessage,
        payload: result.payLoad,
        type: Actions.DeleteKlantKoppelingResponse,
      }

      return dispatch(reponse)
    } catch (e) {
      const errorReponse: IDeleteKlantgroepAfleverafspraakResponseAction = {
        success: false,
        errorMessage: `fout bij verwijderen klantgroep koppeling: ${e.message}`,
        payload: null,
        type: Actions.DeleteKlantKoppelingResponse,
      }

      return dispatch(errorReponse)
    }
  }
}

export const getDataActionCreator: ActionCreator<
  ThunkAction<
    Promise<IGetKlantKoppelingResponseAction>,
    IApplicationState,
    null,
    IGetKlantKoppelingResponseAction
  >
> = (selectie: IKlantSelectie) => {
  return async (dispatch: Dispatch, getState) => {
    const requestDataAction: IGetKlantKoppelingRequestAction = {
      type: Actions.GetKlantKoppelingRequest,
      payload: selectie,
    }
    dispatch(requestDataAction)
    try {
      const result = await GlnService.getKlantgroepkoppelingen(
        selectie.afleverAfspraakReferentie,
        selectie.vestiging > 0 ? selectie.vestiging : undefined,
        selectie.klantNummer,
        selectie.klantNaam,
        selectie.klantGroepId > 0 ? selectie.klantGroepId : undefined
      )
      const response: IGetKlantKoppelingResponseAction = {
        success: result.success,
        errorMessage: result.errorMessage,
        payload: result.payLoad,
        type: Actions.GetKlantKoppelingResponse,
      }

      if (
        (!result.success && result.errorCode === 404) ||
        (result.success && result.payLoad.length === 0)
      ) {
        response.success = false
        response.errorMessage = 'Geen koppelingen gevonden'
      }

      return dispatch(response)
    } catch (e) {
      const errorResponse: IGetKlantKoppelingResponseAction = {
        success: false,
        errorMessage: `Fout bij het ophalen van de koppelingen: ${e.message}`,
        payload: null,
        type: Actions.GetKlantKoppelingResponse,
      }

      return dispatch(errorResponse)
    }
  }
}

export const getKlantGroepenVestiging: ActionCreator<
  ThunkAction<
    Promise<IGetKlantGroepenVestigingResponseAction>,
    IApplicationState,
    null,
    IGetKlantGroepenVestigingResponseAction
  >
> = (vestiging: number) => {
  return async (dispatch: Dispatch, getState) => {
    const requestDataAction: IGetKlantGroepenVestigingRequestAction = {
      type: Actions.GetKlantGroepenVestigingRequest,
      payload: vestiging,
    }
    dispatch(requestDataAction)

    try {
      const { klantKoppelingState } = getState()
      var alleklantgroepen = klantKoppelingState.alleKlantGroepen
      if (!alleklantgroepen) {
        const result = await GlnService.getKlantgroepen(null, null)
        if (result.success && result.payLoad.length > 0) {
          alleklantgroepen = result.payLoad
          const cacheResponse: IGetKlantGroepenVestigingCacheAction = {
            payload: alleklantgroepen,
            type: Actions.GetKlantGroepenVestigingCache,
          }
          dispatch(cacheResponse)
        } else {
          const message: string =
            result.success || result.errorCode === 404
              ? 'Geen tijdvakken gevonden'
              : result.errorMessage
          const errorResponse: IGetKlantGroepenVestigingResponseAction = {
            success: false,
            errorMessage: message,
            payload: null,
            type: Actions.GetKlantGroepenVestigingResponse,
          }

          return dispatch(errorResponse)
        }
      }

      if (vestiging === VestigingEnum.Geen) {
        const filtered = alleklantgroepen.filter(s =>
          s.defaultIndicatie.toString().includes('N')
        )
        const res = filtered.map(item => {
          const desc: SelectieDescriptor = {
            code: item.klantGroepId,
            omschrijving:
              item.klantGroepCode.toString() +
              '-' +
              (item.klantGroepOmschrijving.length > 15
                ? item.klantGroepOmschrijving.substring(0, 15)
                : item.klantGroepOmschrijving),
          }
          return desc
        })

        const def: SelectieDescriptor[] = [{ code: 0, omschrijving: 'N.v.t.' }]

        const selectieResponse: IGetKlantGroepenSelectieResponseAction = {
          success: true,
          payload: def.concat(res),
          type: Actions.GetKlantGroepenSelectieResponse,
        }
        dispatch(selectieResponse)

        const response: IGetKlantGroepenVestigingResponseAction = {
          success: true,
          payload: null,
          type: Actions.GetKlantGroepenVestigingResponse,
        }

        return dispatch(response)
      } else {
        const filtered = alleklantgroepen
          .filter(s => s.defaultIndicatie.toString().includes('N'))
          .filter(t =>
            t.vestigingCode.toString().includes(vestiging.toString())
          )
        const res = filtered.map(item => {
          const desc: SelectieDescriptor = {
            code: item.klantGroepId,
            omschrijving:
              item.klantGroepCode.toString() +
              '-' +
              (item.klantGroepOmschrijving.length > 15
                ? item.klantGroepOmschrijving.substring(0, 15)
                : item.klantGroepOmschrijving),
          }
          return desc
        })

        const def: SelectieDescriptor[] = [
          { code: 0, omschrijving: 'Selecteer Tijdvak...' },
        ]

        const response: IGetKlantGroepenVestigingResponseAction = {
          success: true,
          payload: def.concat(res),
          type: Actions.GetKlantGroepenVestigingResponse,
        }
        return dispatch(response)
      }
    } catch (e) {
      const errorResponse: IGetKlantGroepenVestigingResponseAction = {
        success: false,
        errorMessage: `Fout tijdens ophalen klantgroepen: ${e.message}`,
        payload: null,
        type: Actions.GetKlantGroepenVestigingResponse,
      }

      return dispatch(errorResponse)
    }
  }
}

export const getKlantGegevens: ActionCreator<
  ThunkAction<
    Promise<IGetKlantGegevensResponseAction>,
    IApplicationState,
    null,
    IGetKlantGegevensResponseAction
  >
> = (klantnummer: number) => {
  return async (dispatch: Dispatch, getState) => {
    const requestDataAction: IGetKlantGegevensRequestAction = {
      type: Actions.GetKlantGegevensRequest,
      payload: klantnummer,
    }
    dispatch(requestDataAction)
    try {
      const result = await GlnService.getKlantGegevens(klantnummer)
      const response: IGetKlantGegevensResponseAction = {
        success: result.success,
        errorMessage: result.errorMessage,
        payload: result.payLoad,
        type: Actions.GetKlantGegevensResponse,
      }

      if (
        (!result.success && result.errorCode === 404) ||
        (result.success && !result.payLoad)
      ) {
        response.success = false
        response.errorMessage = 'Klant niet gevonden of niet geldig'
      }

      return dispatch(response)
    } catch (e) {
      const errorResponse: IGetKlantGegevensResponseAction = {
        success: false,
        errorMessage: `Fout tijdens ophalen klant: ${e.message}`,
        payload: null,
        type: Actions.GetKlantGegevensResponse,
      }

      return dispatch(errorResponse)
    }
  }
}

export const getKlantAfleverafspraken: ActionCreator<
  ThunkAction<
    Promise<IGetKlantAfleverafsprakenVestigingResponseAction>,
    IApplicationState,
    null,
    IGetKlantAfleverafsprakenVestigingResponseAction
  >
> = (vestiging: number, klantNummer: number) => {
 var search = {vestiging: vestiging, klantNummer: klantNummer}
  return async (dispatch: Dispatch, getState) => {
    const requestDataAction: IGetKlantAfleverafsprakenVestigingRequestAction = {
      type: Actions.GetKlantAfleverafsprakenVestigingRequest,
      payload: search,
    }
    dispatch(requestDataAction)
    try {
      const def: SelectieDescriptor[] = [{ code: 0, omschrijving: 'N.v.t.' }]
      var afleverafspraken: IKlantAfleverafspraak[] = []
      const result = await GlnService.getAfleverafsprakenPerVestigingPerKlant(vestiging, klantNummer)
      if (result != null && result.success) {
        afleverafspraken = result.payLoad
      }
      const res = afleverafspraken.map(item => {
        const desc: SelectieDescriptor = {
          code: item.klantAfleverafspraakId,
          omschrijving: item.afleverafspraakReferentie,
        }
        return desc
      })

      const response: IGetKlantAfleverafsprakenVestigingResponseAction = {
        success: result.success,
        errorMessage: result.errorMessage,
        payload: def.concat(res),
        type: Actions.GetKlantAfleverafsprakenVestigingResponse,
      }

      if (
        (!result.success && result.errorCode === 404) ||
        (result.success && !result.payLoad)
      ) {
        response.success = false
        response.errorMessage = 'Afleverafspraken niet gevonden of niet geldig'
      }

      return dispatch(response)
    } catch (e) {
      const errorResponse: IGetKlantAfleverafsprakenVestigingResponseAction = {
        success: false,
        errorMessage: `Fout tijdens ophalen van afleverafspraken: ${e.message}`,
        payload: null,
        type: Actions.GetKlantAfleverafsprakenVestigingResponse,
      }

      return dispatch(errorResponse)
    }
  }
}
